
import { Component, Input, EventEmitter, Output, OnInit } from "@angular/core";
import { Idioma } from 'shared/entities/idioma.entity';
import { TranslateService } from 'shared/translate';
import { CookieService } from 'ngx-cookie-service';
import { IdiomaService } from 'projects/administrativo/src/app/services/idioma.service';

@Component({
    selector: "selecionaoidioma",
    templateUrl: "./selecionaidioma.component.html",
    styleUrls: ["./selecionaidioma.component.scss"]
})
export class SelecionaIdiomaComponent implements OnInit {

    constructor(private translate: TranslateService, private cookieService: CookieService, private idiomaService: IdiomaService) { }
    @Input() Idiomas: Idioma[];

    public
     IdiomaSelecionado: Idioma=null;

    ngOnInit(): void {

        let idioma = this.Idiomas.find(d=>d.Sigla.toLowerCase() == this.translate.currentLang.toLowerCase());
        if (idioma)
        this.IdiomaSelecionado = idioma;
        else
        this.IdiomaSelecionado = this.Idiomas[0];

        this.idiomaService.PreencherIdioma(this.IdiomaSelecionado);
    }

    TrocarIdioma(): void
    {
        var d = new Date();
        var year = d.getFullYear();
        var month = d.getMonth();
        var day = d.getDate();
        var c = new Date(year + 1, month, day);
        this.cookieService.set("IdiomaCookie", this.IdiomaSelecionado.Sigla, { expires:c})
        this.translate.use(this.IdiomaSelecionado.Sigla);
        this.idiomaService.PreencherIdioma(this.IdiomaSelecionado);
        //window.location.reload();
    }

}
